import React, { Component } from 'react';
import ResultItem from './ResultItem';
import DomainPagination from '../../DomainPagination/DomainPagination';
import Screen from '../../Screen/Screen';

class ResultList extends Component {
  render() {
    return (
      <div className="result-container">
        <div className="item-wraper">
          <Screen />
          <ResultItem />
          <DomainPagination />
        </div>
      </div>
    );
  }
}
export default ResultList;


// WEBPACK FOOTER //
// ./src/components/Content/Result/ResultList.js